import GeckoRequest from "../services/gecko-request";

const updateUserAvailability = (user, override) => {
  user.web_available = override === undefined ? !user.web_available : override
  return GeckoRequest.post(`/agent/availability`, {
    webAvailable: user.web_available,
    mobileAvailable: user.mobile_available,
  });
}

const updateUserMobileAvailability = (user, override) => {
  user.mobile_available = override === undefined ? !user.mobile_available : override;
  return GeckoRequest.post(`/agent/availability`, {
    webAvailable: user.web_available,
    mobileAvailable: user.mobile_available,
  })
}

export default {
  updateUserAvailability,
  updateUserMobileAvailability
}